import qoalaStorage from '~/core/Storage';

export default () => ({
  tropicalDiseasePurchaseData: JSON.parse(qoalaStorage.getItem('tropicalDiseasePurchaseData') || '{}'),
  listProduct: JSON.parse(qoalaStorage.getItem('tropicalDiseaseProduct')),
  productDetail: JSON.parse(qoalaStorage.getItem('tropicalDiseaseProductDetail')),
  claims: {}
});
